import './CustomPagination.style';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CustomPaginationLink from 'Component/CustomPaginationLink';
import TextPlaceholder from 'Component/TextPlaceholder';

export default class CustomPagination extends PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool,
        onPageSelect: PropTypes.func.isRequired,
        totalPages: PropTypes.number.isRequired,
        currentPage: PropTypes.number.isRequired,
        paginationFrame: PropTypes.number,
        paginationFrameSkip: PropTypes.number,
        anchorTextPrevious: PropTypes.string,
        anchorTextNext: PropTypes.string
    };

    static defaultProps = {
        isLoading: false,
        paginationFrame: 5,
        paginationFrameSkip: 4,
        anchorTextPrevious: '',
        anchorTextNext: ''
    };

    renderPreviousPageLink(page) {
        const { anchorTextPrevious } = this.props;

        return this.renderPageLink(page, __('Previous page'), false, anchorTextPrevious || '◄');
    }

    renderPageLinks() {
        const {
            totalPages,
            paginationFrame,
            paginationFrameSkip,
            currentPage
        } = this.props;
        let pages = [];
        let i;

        // Render next pagination links
        for (i = currentPage; i <= currentPage + paginationFrame; i++) {
            if (i <= totalPages && pages.length <= paginationFrameSkip) {
                pages.push(this.renderPageLink(i, __('Page %s', i), i === currentPage, i.toString()));
            }
        }

        // Render previous pagination links if necessary
        for (i = 1; i < currentPage; i++) {
            if (pages.length < paginationFrame) {
                const id = currentPage - i;
                const pageData = this.renderPageLink(id, __('Page %s', id), false, id.toString());

                pages = [pageData, ...pages];
            }
        }

        // Edge case for rendering correct count of next links when current page is 1
        if (currentPage === 1 && pages.length < totalPages) {
            for (i = pages.length + 1; i <= paginationFrame; i++) {
                pages.push(this.renderPageLink(i, __('Page %s', i), false, i.toString()));
            }
        }

        return pages;
    }

    renderNextPageLink(page) {
        const { anchorTextNext } = this.props;

        return this.renderPageLink(page, __('Next page'), false, anchorTextNext || '►');
    }

    renderPageLink(pageNumber, label, isCurrent, text) {
        const { onPageSelect } = this.props;

        return (
            <li
              key={ pageNumber }
              block="CustomPagination"
              elem="ListItem"
            >
                <CustomPaginationLink
                  text={ text }
                  label={ label }
                  getPage={ onPageSelect }
                  isCurrent={ isCurrent }
                  pageNumber={ pageNumber }
                />
            </li>
        );
    }

    renderPlaceholder() {
        return (
            <ul block="CustomPagination" mods={ { isLoading: true } }>
                { Array.from({ length: 4 }, (_, i) => (
                    <li
                      key={ i }
                      block="CustomPagination"
                      elem="ListItem"
                    >
                        <TextPlaceholder length="block" />
                    </li>
                )) }
            </ul>
        );
    }

    render() {
        const { totalPages, currentPage, isLoading } = this.props;

        if (isLoading) return this.renderPlaceholder();

        return (
            <ul block="CustomPagination">
                { currentPage > 1 && this.renderPreviousPageLink(currentPage - 1)}
                { this.renderPageLinks() }
                { currentPage <= totalPages - 1 && this.renderNextPageLink(currentPage + 1) }
            </ul>
        );
    }
}
